__webpack_require__.p = "/PRIMECUT/";